<div class="dialog-content-max">
    <form [formGroup]="regionform">
        <div class="formgrid grid">
            <div class="field col-12">
                <label for="regionname" class="required-label">Region Name<span class="maxchars">(Max 100 chars)</span><span>*</span></label>
                <input type="text" class="form-control" id="name" inputId="name" placeholder="Enter Region Name" name="name" formControlName="name" required>
                <span class="errormessage"
                *ngIf="regionform.get('name').invalid && (regionform.get('name').dirty || regionform.get('name').touched)">
                {{ getErrorMessage(regionform, validation_message, 'name') }}
                </span> 
            </div>

        </div>

        <div class="formgrid grid" *ngIf="isEdit">
            <div class="field col-12">
                <label for="activeflag" class="required-label">Active Flag<span>*</span></label>
                <p-dropdown [options]="activeFlag" inputId="activeflag" [filter]="true" appendTo="body" name="activeflag"
                    optionLabel="labelname" optionValue="value" placeholder="Select Flag" formControlName="activeflag"></p-dropdown>
    
                <span style="color:red" *ngIf="regionform.get('activeflag').invalid && regionform.get('activeflag').touched">
                    {{getErrorMessage(regionform, validation_message, 'activeflag')}}
                </span>    
            </div>
        </div>

       
    </form>

    <div class="custom-dialog-footer">
        <p-button class="m-1" label="Close" styleClass="customeclose"  (click)="closemodal(regionform,this.ref,'Are you sure you want to close?')"></p-button>
        <p-button class="m-1" *ngIf="this.isSupportLimited == 'N'" label="{{saveTitle}}" styleClass="customesave" 
        (click)="add()">
    </p-button> </div>
</div>
